import { useEffect, useState } from 'react'

export function useGoogleMaps(lang: string) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      setReady(false)

      const id = 'google-maps-script'
      const prev = document.getElementById(id)
      if (prev) prev.remove()

      if (window.google?.maps) {
        // @ts-ignore
        delete window.google.maps
      }

      await new Promise<void>((resolve, reject) => {
        const s = document.createElement('script')
        s.id = id
        s.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCv99Z0U5BXemwpJ16N0hkhkdzgZCiODtM&libraries=places&language=${lang}`
        s.async = true
        s.defer = true
        s.onload = () => resolve()
        s.onerror = () => reject(new Error('Failed to load Google Maps API'))
        document.head.appendChild(s)
      })

      if (!cancelled) setReady(true)
    }

    if (typeof window !== 'undefined') load().then()
    return () => {
      cancelled = true
    }
  }, [lang])

  return ready
}
